import React  from "react";
import ContentLayout from "../../component/ContentLayout";
// import DataTable from "../../component/DataTable";

const NFT = () => {
  // const [userData, setUserData] = useState([]);
  // const [tableColumns, setTableColumns] = useState([]);
  //
  // const handleSaveUser = async (values: any) => {};
  //
  // const handleCreateUser = async (values: any) => {};
  //
  // const onDelete = (id: any) => {};

  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>NFT +</p>
      <div className={"mt-4 w-full"}>
        <div
          className={
            "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4"
          }
        >
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>200,000</p>
            <p className={"text-white"}>Total Shares</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>200,000</p>
            <p className={"text-white"}>Shareholder Shares</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>0</p>
            <p className={"text-white"}>Company Shares</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>2,520</p>
            <p className={"text-white"}>Total Investors</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>1</p>
            <p className={"text-white"}>Total NFT</p>
          </div>
        </div>
        <div className={"mt-2"}>
          {/*<DataTable*/}
          {/*  columns={tableColumns}*/}
          {/*  data={userData}*/}
          {/*  onCreate={handleCreateUser}*/}
          {/*  onEditSave={handleSaveUser}*/}
          {/*  onDelete={onDelete}*/}
          {/*  valueKey={"column_name"}*/}
          {/*  labelKey={"column_comment"}*/}
          {/*  typeKey={"column_type"}*/}
          {/*  enablePagination={true}*/}
          {/*  enableEditing={true}*/}
          {/*  enableSorting={true}*/}
          {/*  createDisplayMode={"modal"}*/}
          {/*  editDisplayMode={"modal"}*/}
          {/*  state={{*/}
          {/*    columnVisibility: { id: false },*/}
          {/*    density: "comfortable",*/}
          {/*    columnPinning: {*/}
          {/*      right: ["mrt-row-actions"],*/}
          {/*    },*/}
          {/*  }}*/}
          {/*  recordIdKey={"id"}*/}
          {/*  hideEditFields={[*/}
          {/*    "id",*/}
          {/*    "created_dt",*/}
          {/*    "created_by",*/}
          {/*    "updated_by",*/}
          {/*    "updated_dt",*/}
          {/*  ]}*/}
          {/*  selectionOption={{*/}
          {/*    active: [*/}
          {/*      { label: "Yes", value: true },*/}
          {/*      { label: "No", value: false },*/}
          {/*    ],*/}
          {/*  }}*/}
          {/*  createRecordTitle={"Create User"}*/}
          {/*/>*/}
        </div>
      </div>
    </ContentLayout>
  );
};

export default NFT;
